import React from 'react';

/**
 * Reusable Empty-State (Phase 9).
 *
 * Layout: icône outline ronde + titre + sous-titre optionnel + bouton action.
 * Style sobre — bg #F5F6FA, coeur sur #FFFFFF via card container ancestor.
 *
 * Props:
 *  - Icon:        lucide-react component (outline).
 *  - title:       principal (h3 gras).
 *  - description: optional sub-line.
 *  - action:      optional { label, onClick, testId } — rendered as primary
 *                 gradient button. If omitted, no button is shown.
 *  - testId:      root data-testid (falls back to 'empty-state').
 */
export default function EmptyState({ Icon, title, description, action, testId = 'empty-state' }) {
    return (
        <div
            data-testid={testId}
            className="flex flex-col items-center justify-center text-center py-12 px-6"
        >
            {Icon && (
                <div className="mb-4 w-14 h-14 rounded-full bg-[#4B3FD8]/10 flex items-center justify-center">
                    <Icon size={26} strokeWidth={1.5} className="text-[#4B3FD8]" />
                </div>
            )}
            <div className="text-[15px] font-semibold text-[#1A1D2E]">
                {title}
            </div>
            {description && (
                <div className="text-sm text-[#6B7280] mt-1 max-w-[420px]">
                    {description}
                </div>
            )}
            {action && (
                <button
                    type="button"
                    data-testid={action.testId || 'empty-state-action'}
                    onClick={action.onClick}
                    className="mt-5 inline-flex items-center gap-2 h-10 px-4 rounded-lg bg-gradient-to-r from-[#4B3FD8] to-[#9B7FF4] text-white text-sm font-semibold hover:opacity-95"
                >
                    {action.Icon && <action.Icon size={16} strokeWidth={2} />}
                    {action.label}
                </button>
            )}
        </div>
    );
}
